
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { EventTemplate } from 'src/app/core-module/models/Events/event-template';
import { EventsService } from 'src/app/core-module/services/events.service';
import { SharedActionBarComponent } from '../../shared-action-bar/shared-action-bar.component';
import { ConfirmationService } from 'primeng/api';
import { CustomerTermPipe } from 'src/app/shared-module/pipes/customer-term.pipe';

@Component({
  selector: 'app-event-templates',
  standalone: true,
  imports: [RouterModule, CardModule, ButtonModule, TableModule, ConfirmPopupModule, SharedActionBarComponent, CustomerTermPipe],
  providers: [ConfirmationService],
  templateUrl: './event-templates.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./event-templates.component.scss']
})
export class EventTemplatesComponent implements OnInit {
  templates: EventTemplate[] = [];
  loading = false;
  private deleteInFlight = false;

  constructor(private eventsService: EventsService, private router: Router, private confirmationService: ConfirmationService) {}

  ngOnInit(): void {
    this.loadTemplates();
  }

  loadTemplates(): void {
    this.loading = true;
    this.eventsService.getEventTemplates().subscribe({
      next: res => {
        this.templates = (res?.Templates ?? []).filter(t => t.Active !== false);
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  newTemplate(): void {
    this.router.navigate(['/settings/events/templates/new']);
  }

  editTemplate(t: EventTemplate): void {
    this.router.navigate([`/settings/events/templates/${t.EventWorkflowID}`]);
  }

  deleteTemplate(t: EventTemplate, event: Event): void {
    this.confirmationService.confirm({
      key: 'eventTemplateDelete',
      target: event.target as EventTarget,
      message: `Remove template "${t.TemplateName || t.WorkflowName}"?`,
      header: 'Remove template',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'reject',
      acceptButtonStyleClass: 'confirm-remove-btn',
      rejectButtonStyleClass: 'confirm-keep-btn',
      accept: () => {
        if (this.deleteInFlight) return;
        this.deleteInFlight = true;
        this.eventsService.deleteEventTemplate(t.EventWorkflowID).subscribe({
          next: () => {
            this.deleteInFlight = false;
            this.loadTemplates();
          },
          error: () => {
            this.deleteInFlight = false;
            this.loadTemplates();
          }
        });
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  onConfirmReject(confirmation: any){
    confirmation?.rejectEvent?.emit();
    this.confirmationService.close();
  }

  onConfirmAccept(confirmation: any){
    confirmation?.acceptEvent?.emit();
    this.confirmationService.close();
  }
}
